import React from 'react'
type Props = {
  message: string
}
const ActiveError: React.FC<Props> = ({message}) => {
  return (
    <div className={'mt-12'}>
      <div className='d-flex justify-content-center'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='100'
          height='100'
          fill='red'
          className='bi bi-x-circle'
          viewBox='0 0 16 16'
        >
          <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16' />
          <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708' />
        </svg>
      </div>
      <div className={'text-center fs-3 mt-10 text-danger fw-bolder'}>
        <div className={'mt-5'}>
          <strong>{message}</strong>
        </div>
      </div>
    </div>
  )
}

export {ActiveError}
